import { setLoading, stopLoading } from './actions';
const initialState = 'idle';
function isLoadingReducer(state = initialState, { type, payload }) {
    switch (type) {
        case setLoading.toString():
            return payload;
        case stopLoading.toString():
            return 'idle';
        default:
            return state;
    }
}
export default isLoadingReducer;
